var checkBrowser = require('springfeed-web-browser-support');
checkBrowser({
	'Chrome': 57,
	'Safari': 11,
	'Firefox': 52,
	'Opera': 44,
	'IE': 11,
	'Edge': 16,
	'Chrome Mobile': 0,
	'Safari Mobile': 0,
	'Firefox Mobile': 0,
	'Samsung Browser': 0,
	'UC Browser': 0,
	'Edge Mobile': 0
});


// WEBPACK FOOTER //
// ./source/support.js